import moment from 'moment'
import { WOJEWODZTWA } from '@/pages/system/Uzytkownicy/utils/wojewodztwa'

export const MANUAL_COLORS = [
	{ id: 'emerald', swatch: 'bg-emerald-400', cell: 'bg-emerald-400 text-emerald-950' },
	{ id: 'amber', swatch: 'bg-amber-300', cell: 'bg-amber-300 text-amber-950' },
	{ id: 'violet', swatch: 'bg-violet-300', cell: 'bg-violet-300 text-violet-950' },
	{ id: 'red', swatch: 'bg-red-400', cell: 'bg-red-400 text-red-950' },
	{ id: 'sky', swatch: 'bg-sky-300', cell: 'bg-sky-300 text-sky-950' },
	{ id: 'pink', swatch: 'bg-pink-300', cell: 'bg-pink-300 text-pink-950' },
	{ id: 'orange', swatch: 'bg-orange-300', cell: 'bg-orange-300 text-orange-950' },
	{ id: 'yellow', swatch: 'bg-yellow-300', cell: 'bg-yellow-300 text-yellow-950' },
]

const VOIVODESHIP_HEADER = {
	LUB: 'bg-amber-200',
	PDK: 'bg-pink-200',
	ŚW: 'bg-sky-200',
	MŁP: 'bg-emerald-200',
	ŚL: 'bg-orange-200',
	ŁDZ: 'bg-lime-200',
	DLN: 'bg-cyan-200',
	WLKP: 'bg-yellow-200',
	KUJ: 'bg-rose-200',
	ZPOM: 'bg-teal-200',
	POM: 'bg-blue-200',
	MAZ: 'bg-fuchsia-200',
	PODL: 'bg-indigo-200',
	WARM: 'bg-red-200',
	OPL: 'bg-purple-200',
	LBS: 'bg-green-200',
}

const STATUS_CLASS = {
	available: 'bg-emerald-400 text-emerald-950',
	morning: 'bg-emerald-400 text-emerald-950',
	afternoon: 'bg-emerald-400 text-emerald-950',
	weekend: 'bg-red-400 text-red-950',
	unavailable: 'bg-white text-gray-600',
	project: 'bg-white text-indigo-800',
}

export const voivodeshipHeaderClass = code => VOIVODESHIP_HEADER[code] || 'bg-gray-100'

export const voivodeshipOrder = code => {
	const index = WOJEWODZTWA.findIndex(item => item.code === code)
	return index === -1 ? WOJEWODZTWA.length : index
}

export const toDayKey = value => {
	if (!value) return ''
	const raw = `${value}`.trim()
	if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw
	const date = moment(value)
	return date.isValid() ? date.format('YYYY-MM-DD') : ''
}

export const cellKey = (trainerId, day) => `${trainerId}|${day}`

export const buildMonthDays = (year, monthIndex) => {
	const start = moment({ year, month: monthIndex, day: 1 })
	const days = []
	const cursor = start.clone()
	while (cursor.month() === monthIndex) {
		days.push({
			key: cursor.format('YYYY-MM-DD'),
			day: cursor.date(),
			weekday: cursor.isoWeekday(),
			isWeekend: cursor.isoWeekday() >= 6,
		})
		cursor.add(1, 'day')
	}
	return days
}

export const resolveCell = ({ isWeekend, morning, afternoon, project, manualColor }) => {
	let kind = 'unavailable'
	let mark = 'x'

	if (project) {
		kind = 'project'
		mark = ''
	} else if (morning && afternoon) {
		kind = 'available'
		mark = ''
	} else if (morning) {
		kind = 'morning'
		mark = '1/0'
	} else if (afternoon) {
		kind = 'afternoon'
		mark = '0/1'
	} else if (isWeekend) {
		kind = 'weekend'
		mark = 'x'
	}

	const manual = MANUAL_COLORS.find(item => item.id === manualColor)
	return {
		kind,
		mark,
		className: manual ? manual.cell : STATUS_CLASS[kind],
		project,
	}
}
